<ng-container *transloco="let t">
  <label>
    <span class="fw-bold">
       <app-language-output [hrLabel]="raceAdditionalPricingItem?.name"
                            [enLabel]="raceAdditionalPricingItem?.nameEng"
                            [itLabel]="raceAdditionalPricingItem?.nameIta"
                            [siLabel]="raceAdditionalPricingItem?.nameSlo"
                            [defaultLanguage]="defaultLanguage" [languages]="languages"/>,
    </span>
    @if (raceAdditionalPricingItem?.pricingItemValues?.length === 1) {
      {{ ' - ' }}
      <app-language-output [hrLabel]="raceAdditionalPricingItem!.pricingItemValues![0].name"
                           [enLabel]="raceAdditionalPricingItem!.pricingItemValues![0].nameEng"
                           [itLabel]="raceAdditionalPricingItem!.pricingItemValues![0].nameIta"
                           [siLabel]="raceAdditionalPricingItem!.pricingItemValues![0].nameSlo"
                           [defaultLanguage]="defaultLanguage" [languages]="languages"/>
    }
    {{ getPriceLabel() }}
  </label>
</ng-container>
